<template>

  <div class="mx-auto mt-s80 pb-s20 px-s5 max-w-s800 grid grid-cols-2 gap-x-s20 gap-y-s40 m_376:mt-[85px] m_376:px-s10 m_426:px-s20 m_650:px-0 m_650:mt-0 m_650:grid-cols-3 m_800:gap-x-s40 m_1000:max-w-full m_1000:grid-cols-4 m_1000:gap-x-0 m_1300:grid-cols-5">
		<category-quickview v-if="this.showQuickView" :item="this.item"></category-quickview>
		<template v-for="(product, index) in products.data">
			<template v-if="mobile == 1">
				<category-product-mobile :item="product">
				</category-product-mobile>
			</template>
			<template v-else>
				<category-product :item="product">
				</category-product>
			</template>
		</template>

	</div>
</template>

<script>

export default {
	name: "SearchProducts",

	data() {
		return {
			products: this.$attrs.products,
			showQuickView: false,
			item: {},
			mobile: this.$attrs.mobile
		}
	},

}
</script>